import { render } from "./logo-icon.svg?vue&type=template&id=08884ba4"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__